import { useConfigMutation } from "@hooks";

import * as Apis from "../api";

const usePeiMutation = (() => {
  return useConfigMutation({ apis: Apis });
})();

export default usePeiMutation;
